/* eslint-disable max-len */
import { TodaysApptUserFlowSteps } from 'features/order-tracker/pages/order-summary/components/SnapshotCardSection/constants';

export const DATA_INFO = {
  [TodaysApptUserFlowSteps.Init]: {
    paragraph1: {
      title: 'When will your engineer arrive?',
      messages: [
        'Your appointment is scheduled for ',
        '. Please note that our supplier does not give us an exact time when your engineer will visit.',
      ],
      withDynamicData: true,
    },
    paragraph2: {
      title: 'Engineer can arrive anytime between',
      messages: [
        'You may be contacted directly by your engineer, so keep an eye out for any calls or texts on your site contact number above.',
      ],
      withDynamicData: true,
    },
    paragraph3: {
      messages: [
        "If you haven't heard from your engineer, they may be running late. ",
        'Check back here at ',
        ' for further updates.',
      ],
      withDynamicData: true,
    },
  },
  [TodaysApptUserFlowSteps.HalfAnHourBefore]: {
    paragraph1: {
      title: 'Engineer not yet arrived?',
      messages: [
        'You may have been contacted by your engineer, so check for any calls or texts on your site contact number above.',
      ],
    },
    paragraph3: {
      messages: [
        "If you haven't heard from your engineer, they may be running late. Check back here in 30 minutes for further updates.",
      ],
    },
  },
  [TodaysApptUserFlowSteps.EndOfScheduledTimeSlot]: {
    paragraph1: {
      title: 'Engineer arrived and completed your order?',
      messages: [
        'Hopefully everything has gone well for you. We’ll update your order as soon as we hear from our supplier.',
      ],
    },
    paragraph2: {
      title: 'Engineer not arrived?',
      messages: [
        'If you’ve heard from the engineer and arranged a new date, that’s great so there’s no need for you to contact us.',
      ],
    },
    paragraph3: {
      messages: [
        `If you’ve not received any messages or texts from your engineer, we’re sorry about that. Please contact us by “Update details”  and we’ll arrange a new appointment for you.`,
      ],
    },
    paragraph4: {
      title: 'Further assistance?',
      messages: ['If you need any further assistance with setting up your service, go to our '],
      linkUrl: 'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/',
      linkText: 'set-up page',
      linkAnalytics: 'Further assistance:set-up page',
    },
  },
  [TodaysApptUserFlowSteps.EndOfScheduledTimeSlotSuccess]: {
    paragraph1: {
      title: 'Engineer arrived and completed your order?',
      messages: [
        'Hopefully everything has gone well for you. We’ll update your order as soon as we hear from our supplier.',
      ],
    },
    paragraph2: {
      title: 'Engineer not arrived?',
      messages: [
        'If you’ve heard from the engineer and arranged a new date, that’s great so there’s no need for you to contact us.',
      ],
    },
    paragraph3: {
      messages: [
        `If you’ve not received any messages or texts from your engineer, we’re sorry about that. Please contact us by “Update details”  and we’ll arrange a new appointment for you.`,
      ],
    },
    paragraph4: {
      title: 'Further assistance?',
      messages: ['If you need any further assistance with setting up your service, go to our '],
      linkUrl: 'https://business.bt.com/help/guides/getting-started-with-your-bt-business-products/',
      linkText: 'set-up page',
      linkAnalytics: 'Further assistance:set-up page',
    },
  },
};
